import React from 'react';
import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

function HIWActionSection() {
  return (
    <div className="site-section" id="HIWActionSection">
      <Container>
        <Row>

          <Col md={6}>
            <img
              src="/images/bg_2.jpg"
              width="100%"
              alt="Close-up shot of a phone and laptop"
            />

          </Col>
          <Col md={6} className="white">

            <div id="margin-left">
              <br />
              <h6>
                TODAY IS THE DAY
              </h6>
              <h1 className="white">
                It's time to meet your match
              </h1>
              <p>
                Call us crazy, but we believe that connecting with people is what life is all about.

              </p>
              <br />
              <a href="signup" className="btn btn-success btn-hover-white py-3 px-5">
                LET'S GET STARTED
              </a>
            </div>

          </Col>

        </Row>
      </Container>
    </div>
  );
}

export default HIWActionSection;
